import TextFade from "../../components/CustomTexts/TextFade";
//import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/calabar/cal11.jpg";
import sandDredgingImage from "../../assets/calabar/cal14.jpg";
import missionImage from "../../assets/calabar/cal1.jpg";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan2.jpg";
import trainingImg from "../../assets/calabar/cal.jpg";
import chysonImg from "../../assets/calabar/cal12.jpg";
import farmImg from "../../assets/calabar/cal7.jpg";
import consultancyImg from "../../assets/calabar/cal14.jpg";
import consultancy2Img from "../../assets/calabar/cal16.jpg";
import consultancy3Img from "../../assets/calabar/cal1.jpg";
import consultancy4Img from "../../assets/calabar/cal10.jpg";
import consultancy5Img from "../../assets/calabar/cal13.jpg";
import consultancy6Img from "../../assets/calabar/cal15.jpg";
import consultancy7Img from "../../assets/calabar/cal18.jpg";
import consultancy8Img from "../../assets/calabar/cal2.jpg";
import consultancy9Img from "../../assets/calabar/cal3.jpg";
import consultancy10Img from "../../assets/calabar/cal8.jpg";
import consultancy11Img from "../../assets/calabar/cal9.jpg";
import consultancy12Img from "../../assets/calabar/cal6.jpg";
import consultancy13Img from "../../assets/calabar/cal7.jpg";
import consultancy14Img from "../../assets/calabar/cal5.jpg";
import consultancy15Img from "../../assets/calabar/cal4.jpg";
import consultancy16Img from "../../assets/calabar/cal11.jpg";
import consultancy25Img from "../../assets/calabar/cal21.jpg";
//import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const CalabarTraining = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const [activeTab, setActiveTab] = useState("participation");

  const trainingGallery = [
    { img: consultancy7Img, caption: "Hands-On Workshop" },
    { img: trainingImg, caption: "Personalized Mentorship" },
    { img: farmImg, caption: "Empowering Farmers" },
    { img: sandDredgingImage, caption: "Field Experience" },
    { img: consultancyImg, caption: "Consultancy Session" },
    { img: consultancy2Img, caption: "Knowledge Sharing" },
    { img: consultancy3Img, caption: "Community Engagement" },
    { img: consultancy4Img, caption: "Sustainable Practices" },
    { img: consultancy5Img, caption: "Innovative Solutions" },
    { img: consultancy6Img, caption: "Agricultural Training" },
    { img: consultancy8Img, caption: "Empowering Youth" },
    { img: consultancy9Img, caption: "Hands-On Learning" },
    { img: consultancy10Img, caption: "Field Demonstration" },
    { img: consultancy11Img, caption: "Practical Skills" },
    { img: consultancy12Img, caption: "Community Impact" },
    { img: consultancy13Img, caption: "Agribusiness Development" },
    { img: consultancy14Img, caption: "Sustainable Agriculture" },
    { img: consultancy15Img, caption: "Training Session" },
    { img: consultancy16Img, caption: "Empowering Farmers" },
    { img: consultancy25Img, caption: "Value-Addition Workshops" },
    { img: chysonImg, caption: "Market Navigation" },
    { img: missionImage, caption: "Agricultural Innovation" }
  ];

  const tabContent: Record<string, JSX.Element> = {
    participation: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Hands-On Agronomy
                    </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
              In 2020, as the lockdown caused by Covid19 pandemic was lifted, there was an urgent need to increase the production and consumption of high nutrients crops like Orange Fleshed Sweet Potato in order to reduce the vulnerability of the people. </p>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">Some potato farmers in Calabar, Cross River State gathered themselves together for a training on the production, processing and utilization of OFSP in order to save their families and communities and improve their economy.

</p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy7Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    rural: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Post-Harvest & Preservation
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The training included hands-on workshops on post-harvest techniques, preservation methods, and value addition. Participants learned to process OFSP into flour, chips, and other products, enhancing marketability and shelf life.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy2Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    health: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Health, Productivity & Economic empowerment
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The Shabu training embraced a rural impact approach, focusing on sustainable change through technology. Participants learned to cultivate orange-fleshed sweet potato (OFSP) using eco-friendly methods, enhancing food security and nutrition in their communities. The training emphasized practical skills, enabling farmers to adapt to local conditions and market demands.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy4Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    development: (
      <div className="flex flex-col md:flex-row-reverse items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
            Value-Addition Workshops
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The training included hands-on workshops on post-harvest techniques, preservation methods, and value addition. Participants learned to process OFSP into flour, chips, and other products, enhancing marketability and shelf life.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy25Img} alt="Mentorship" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    knowledge: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
            Market Navigation
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Understand pricing, grading standards, packaging, and building relationships with buyers and retailers. With the right knowledge, farmers can navigate the market effectively, ensuring their produce reaches consumers efficiently.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={chysonImg} alt="Knowledge Sharing" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    )
  };

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0" />
        <div className="z-10">
          <TextEffect text="Calabar Training, Cross River" className="hero-title" />
        </div>
      </div>

      {/* Tabbed Pane Section */}
      <div className="px-4 sm:px-[6%] mt-20 mb-24 gap-6">
                <div className="flex flex-wrap justify-center mb-8 space-x-4">
          <button
            onClick={() => setActiveTab("participation")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "participation" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Hands-On Agronomy             </button>

          <button
            onClick={() => setActiveTab("rural")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "rural" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Post-Harvest & Preservation
                 </button>
               
          <button
            onClick={() => setActiveTab("development")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "development" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Value-Addition Workshops          </button>
          <button
            onClick={() => setActiveTab("knowledge")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "knowledge" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Market Navigation
          </button>
        </div>

        <div className="transition-all duration-500">{tabContent[activeTab]}</div>
      </div>


      {/* Overview Section */}
      <div className="relative">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img src={missionImage} alt="Empowering Farmers" className="w-[80%] max-w-[450px]" />
            </div>
            <div className="md:w-[60%] w-full space-y-4">
              <TextFade animation="fade-down">
                <h1 className="text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text4="2-DAY EMPOWERMENT IN OFSP VALUE-CHAIN " />
                  <TextEffect text4="TRAINING DEVELOPMENT" />
                </h1>
              </TextFade>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
             Simdozi International Limited answered this call with a two-day training which took the participants through the health, social and economic benefits of this crop and ended with a practical session establishing their demonstration farm. It was a big eye-opening session that provided entrepreneurship training into OFSP.
              </p>
           </div>
          </div>
        </div>
      </div>
      {/* Gallery Section */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[30px] font-bold text-dark mb-8">
            <TextEffect part4="Calabar Training, Cross River Gallery" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer"
                onClick={() => setModal({ img, caption })}
              >
                <img src={img} alt={caption} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
                  <p className="text-white text-lg font-bold">{caption}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default CalabarTraining;
